import React, { useState, useContext, useEffect } from "react";
import { PiEyeSlashLight } from "react-icons/pi";
import { IoEyeSharp } from "react-icons/io5";
import { context } from "../../contexts";
import * as C from "./styles";
import { CiUser } from "react-icons/ci";
import { CiLock } from "react-icons/ci";
import { Checkbox } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

export default function Login() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);

  const [remenber, setRemenber] = useState(false);
  const { RunLogin, setSuport, loaderLogin, setLoaderLogin } =
    useContext(context);

  /** 
    useEffect(() => {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
            window.location.href = "/pagina-de-erro"; // Redireciona para uma página de erro
        }
    }, []);
*/
  function Login(e) {
    const userLimpo = user.trim();
    const passwordLimpa = password.trim();
    e.preventDefault();
    if (userLimpo === "" || passwordLimpa === "") {
      toast.info("Preencha os campos vazios");
      return;
    }
    if (userLimpo.length < 4) {
      toast.warning("O usuário deve ter pelo menos 4 caracteres.");
      return;
    }
    if (passwordLimpa.length < 6) {
      toast.warning("A senha deve ter pelo menos 6 caracteres.");
      return;
    } else {
      if (user === "SUPORTE") {
        setSuport(true);
        RunLogin(user, password, remenber);
      } else {
        setSuport(false);
        RunLogin(user, password, remenber);
      }
    }
  }

  useEffect(() => {
    setLoaderLogin(false);
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("Credentials");
    if (saved) {
        const data = JSON.parse(saved);
        setUser(data.Usuario);
        setRemenber(true);
    }
}, []);

  //CRIANDO LOPPING DE FUNÇÃO A MAISSS PRA REALIZAR TAL TAREFA PRECISA DE CORAGEN , GARRA E TUDO MAIS
  //TUDO QE O USUARIO DIGITAR FICA EM CAIXA ALTA
  function OnchangeText(e) {
    setUser(e.target.value.toUpperCase());
  }

  return (
    <C.Container>
      <div className="container-left">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={require("./../../assets/parceiro.png")}
            alt="Portal do parceiro"
          />
        </div>
      </div>

      <C.Content>
        <div className="header">
          <div className="container-image">
            <img
              className="logo"
              src={require("./../../assets/data-management.png")}
              alt="logo"
            />
          </div>

          <h1>Portal do Parceiro</h1>
          <h2>Entre na sua conta</h2>
        </div>

        <C.Form>
          <form>
            <C.ContainerInput>
              <C.Label>Usuário</C.Label>
              <div className="icon">
                <C.Input
                  type="text"
                  placeholder="Digite o usuário"
                  value={user}
                  onChange={OnchangeText}
                />

                <CiUser size={24} color="grey" />
              </div>
            </C.ContainerInput>
            <C.ContainerInput>
              <C.Label>Senha</C.Label>
              <div className="icon">
                <C.Input
                  type={visible ? "text" : "password"}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <div style={{ display: "flex", alignItems: "center" }}>
                  {visible ? (
                    <PiEyeSlashLight
                      onClick={() => setVisible(false)}
                      style={{ right: 50, cursor: "pointer" }}
                      size={24}
                      color="grey"
                    />
                  ) : (
                    <IoEyeSharp
                      onClick={() => setVisible(true)}
                      style={{ right: 50, cursor: "pointer" }}
                      size={24}
                      color="grey"
                    />
                  )}

                  <CiLock size={24} color="grey" />
                </div>
              </div>
            </C.ContainerInput>
            <div className="remenber">
              <Checkbox
                value={remenber}
                onClick={() => setRemenber(!remenber)}
              />
              <label>Lembrar de mim</label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <button onClick={Login} className="button">
                {" "}
                {loaderLogin ? (
                  <CircularProgress color="inherit" size={16} />
                ) : (
                  "Entrar"
                )}{" "}
              </button>
            </div>
          </form>
        </C.Form>
      </C.Content>
    </C.Container>
  );
}
